import React from "react";
import styled from "styled-components";
import { rem } from "polished";

const Title = styled.p`
	font-family: sans-serif;
`;

const Wrap = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: ${rem(15)};
	margin-bottom: ${rem(25)};
	margin-top: ${rem(11)};
	max-width: ${rem(350)};
`;

const Color = styled.div`
	border: ${(props) =>
		props.active === "yes" ? "2px solid #CC6F4C" : "1px solid #c9c9c9"};
	border-radius: 6px;
	max-width: 162px;
	display: flex;
	align-items: center;
	padding: ${rem(6)} ${rem(8)};
	font-family: sans-serif;
	font-size: 15px;
	cursor: pointer;
`;

const Circle = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	border: 2px solid #fff;
	margin-right: ${rem(10)};
`;

const colorPicker = ({ color, setColor, options, setModelId }) => {
	return (
		<div>
			<Title>Select Colour</Title>
			<Wrap>
				{options.map((item, index) => {
					return (
						<Color
							key={index}
							active={color === index ? "yes" : "no"}
							onClick={() => {
								setColor(index);
								setModelId(item.modelUID);
							}}
						>
							<Circle style={{ backgroundColor: item.color }}></Circle>
							<p>{item.label}</p>
						</Color>
					);
				})}
			</Wrap>
		</div>
	);
};

export default colorPicker;
